<template>
  <f7-page name="about-us">
    <bc-navbar></bc-navbar>
      <!-- Loader -->
      <h2 class="page_title">ABOUT US</h2>

      <div class="buttons-row">
        <a :href="'#' + tabMedia"  class="tab-link button"
           v-bind:style= "[ isMedia ? borderStyle : {'background-color':'#fff','color': '#000'}]"
           :class="{ active: isMedia }" v-on:click="setMedia">Media</a>
        <a :href="'#' + tabBio"    class="tab-link button"  v-bind:style= "[isBio ? borderStyle : {'background-color':'#fff','color': '#000'}]"
           :class="{ active: isBio }" v-on:click="setBio">Bio</a>
        <a :href="'#' + tabSocial" class="tab-link button"  v-bind:style= "[isSocial ? borderStyle : {'background-color':'#fff','color': '#000'}]"
        :class="{ active: isSocial }" v-on:click="setSocial">Social</a>
      </div>


      <div id="focusDiv" v-if="show" class="tabs-animated-wrap"   >
        <div class="tabs" :style="{transform: 'translate3d('+activeTabUsage+'%, 0px, 0px)'}"> <!--Because somehow f7 cant recognize own styles -->
          <div :id="tabMedia" style="overflow-y:hidden" class="page-content tab"  :class="{ active: isMedia }">
            <div>
              <div v-if="model.dealerYoutube" class="page_single layout_fullwidth_padding">
                <div class="videocontainer">
                  <div class="fluid-width-video-wrapper">
                    <iframe class="video" :src="model.dealerYoutube" frameborder="0"></iframe>
                  </div>
                </div>
              </div>
              <h2 class="page_title">PHOTOS</h2>

              <div v-if="model.dealerPhotos">
                <ul id="photoslist" v-bind:class="{'photo_gallery_13': imageViewId == 0, 'photo_gallery_12': imageViewId == 1, 'photo_gallery_11': imageViewId == 2}">
                <li :image="image" v-for="(image,key) in model.dealerPhotos" :key="key">
                  <a rel="gallery-3" href="#" @click.prevent="openPhotoBrowser(key)" class="swipebox">
                    <img :src="image" alt="image">
                  </a>
                </li>
                <div class="clearleft"></div>
                </ul>
                <div style="clear:both"></div>
              </div>
                <div v-if="isMedia" class="bottombarpages" :style="{ 'background-color': customization.mainColor }" >
                  <div class="gallery_switch" >
                    <a href="#" @click="changeImageView(0)" id="view13" class="switcher active">
                      <span class='icon-customer-app icon-switch13'  :style="[ imageViewId == 0 ? {  'color': customization.iconColor } : {'color':customization.fontColor }]"></span>
                        </a>
                    <a href="#" @click="changeImageView(1)" id="view12" class="switcher">
                        <span class='icon-customer-app icon-switch12'  :style="[ imageViewId == 1 ? {  'color': customization.iconColor } : {'color':customization.fontColor }]"></span>
                      </a>
                    <a href="#" @click="changeImageView(2)" id="view11" class="switcher">
                         <span class='icon-customer-app icon-switch11'  :style="[ imageViewId == 2 ? {  'color': customization.iconColor } : {'color':customization.fontColor }]"></span>
                    </a>
                  </div>
                </div>
            </div>
          </div>
          <div :id="tabBio" class="tab page-content"  :class="{ active: isBio }">
            <div class="page_single layout_fullwidth_padding m-t-40">
              <blockquote id="info"  :style="borderStyle">

              </blockquote>
            </div>
          </div>
          <div :id="tabSocial" class="tab page-content" :class="{ active: isSocial }">
              <ul v-if="model.socialLinks.length>0" class="social_share">
                  <li v-if="model.socialLinks[socialEnum.twitter].value" >
                      <a @click="LogActivity('TWITTER')" :href="model.socialLinks[socialEnum.twitter].value"  class="external" target="_blank">
                          <img src="../../../static/images/icons/black/twitter.png" alt="" title="">
                          <span>TWITTER</span>
                      </a>
                  </li>
                  <li v-if="model.socialLinks[socialEnum.facebook].value">
                      <a  @click="redirectToFacebookApp()" class="external" >
                          <img src="../../../static/images/icons/black/facebook.png" alt="" title="">
                          <span>FACEBOOK</span>
                      </a>
                  </li>
<!--                   <li v-if="model.youtubeLink">
                      <a @click="LogActivity('YOUTUBE')"  :href="model.youtubeLink" class="external" target="_blank">
                          <img src="../../../static/images/icons/black/youtube.png" alt="" title="">
                          <span>YOUTUBE</span>
                      </a>
                  </li>
                  <li v-if="model.instagramLink">
                      <a @click="LogActivity('INSTAGRAM')" :href="model.instagramLink" class="external" target="_blank">
                          <img src="../../../static/images/icons/black/instagram.png" alt="" title="">
                          <span>INSTAGRAM</span>
                      </a>
                  </li> -->
                  <li v-if="model.socialLinks[socialEnum.pinterest].value">
                      <a @click="LogActivity('PINTEREST')" :href="model.socialLinks[socialEnum.pinterest].value" class="external" target="_blank">
                          <img src="../../../static/images/icons/black/pinterest.png" alt="" title="">
                          <span>PINTEREST</span>
                      </a>
                  </li>
                  <li v-if="model.socialLinks[socialEnum.linkedin].value">
                      <a @click="LogActivity('LINKEDIN')" :href="model.socialLinks[socialEnum.linkedin].value" class="external" target="_blank">
                          <img src="../../../static/images/icons/black/linkedin.png" alt="" title="">
                          <span>LINKEDIN</span>
                      </a>
                  </li>
              </ul>
          </div>
        </div>

      </div>
       <f7-photo-browser ref="pb" :init="false">
      </f7-photo-browser>
  </f7-page>
</template>
<script>
import { LoopingRhombusesSpinner } from 'epic-spinners'
import { mapState } from 'vuex'
import AboutMixin from '../../mixins/about.common.mixin'

/* eslint-disable */
export default {
  name: 'about-us',
  components: {
    LoopingRhombusesSpinner
  },
  mixins:[
    AboutMixin
  ],
  mounted: function () {
    this.$store.dispatch('about/getAboutUsData').then(function(x){
      this.show = false
      this.$store.dispatch('about/getFacebookDeepLink');
      this.$nextTick(() => {
        this.show = true

      })
    }.bind(this)).catch(x => this.$f7.mainView.router.load({url: 'error'}))
    this.updateTabs()
  },
  updated:function(){
    var elem = document.getElementById("info");
    if(this.model && elem)
        elem.innerHTML = this.model.dealerInfo;
  },
  computed:{
      ...mapState({
      facebookDeepLink: state => state.about.facebookDeepLink,
      model: state => state.about.aboutUsData,
      photos: state => state.about.aboutUsData.dealerPhotos,
      socialEnum: state => state.about.SocialNameEnum
    }),
     borderStyle: function(){
      var borderStyle = this.customization.borderOn ? 'solid 1px ' + this.customization.borderColor :  'none';
      var backgroundStyle = this.customization.mainColor;
      var colorStyle = this.customization.fontColor
      return {
        border: borderStyle,
        background: backgroundStyle,
        color:colorStyle
      };
     }
  },
  methods: {
    redirectToFacebookApp(){
      if(!this.facebookDeepLink)
      {
        window.open(this.model.socialLinks[this.socialEnum.facebook].value,'_blank');
      }
      else{
        setTimeout(function () {
          window.open(this.model.socialLinks[this.socialEnum.facebook].value,'_blank');
        }.bind(this), 1500);
        location.href = this.facebookDeepLink;
      }
      this.LogActivity('FACEBOOK');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-content{
  padding: 0 !important;
}
.page-content.tab:not(.active){
    height: 90vh;
}
.video {
  width: 100%;
  min-height: 250px;
}
blockquote{
  font-size: 17px;
}
 .img-3-row{
    width: 33.3%;
  }
  .img-2-row{
    width: 50%;
  }
  .img-1-row{
    width: 100%;
  }

  .image-container
  {
    max-height: 80%
  }
  .ul.photo_gallery_13{
    margin: 15px 5% 0px 5%;
  }
  .video{
    width:100%;
    min-height: 250px;
  }
  .tabs-animated-wrap{
    height: unset;
  }
  .photo_container{
    width: 90%;
    padding: 0 5%;
    display: flex;
    flex-wrap:wrap;
    margin-bottom: 70px;
  }
  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .photo_wrapper{
    max-height: 250px;
    margin: 5px;
  }
  .photo_wrapper-1{
    width: 30%;
  }

  .photo_wrapper-2{
    width: 45%;
  }

  .photo_wrapper-3{
    width: unset;
  }
  ul.photo_gallery_13 li{
    margin: 5px;
    width: 30%;
  }
  ul.photo_gallery_12 li{
    margin: 5px;
    width: 45%;
  }
  ul.photo_gallery_11 li{
    margin: 5px;
    width: unset;
  }
  ul.photo_gallery_13 li a img{
    height: 100%;
    max-height:250px;
    object-fit: cover;
  }
  ul.photo_gallery_12 li a img{
    height: 100%;
    max-height:250px;
    object-fit: cover;
  }
  ul.photo_gallery_11 li a img{
    height: 100%;
    max-height:250px;
    object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// about-us.vue?1265f85f